var _rect, _path, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegleta2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 80,
    viewBox: "0 0 76 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 1,
    width: 36,
    height: 78,
    stroke: "black",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.7756 41V39.858L38.8054 36.8878C39.0952 36.5952 39.3366 36.3352 39.5298 36.108C39.723 35.8807 39.8679 35.6605 39.9645 35.4474C40.0611 35.2344 40.1094 35.0071 40.1094 34.7656C40.1094 34.4901 40.0469 34.2543 39.9219 34.0582C39.7969 33.8594 39.625 33.706 39.4062 33.598C39.1875 33.4901 38.9389 33.4361 38.6605 33.4361C38.3736 33.4361 38.1222 33.4957 37.9062 33.6151C37.6903 33.7315 37.5227 33.8977 37.4034 34.1136C37.2869 34.3295 37.2287 34.5866 37.2287 34.8849H35.7244C35.7244 34.331 35.8509 33.8494 36.1037 33.4403C36.3565 33.0312 36.7045 32.7145 37.1477 32.4901C37.5938 32.2656 38.1051 32.1534 38.6818 32.1534C39.267 32.1534 39.7813 32.2628 40.2244 32.4815C40.6676 32.7003 41.0114 33 41.2557 33.3807C41.5028 33.7614 41.6264 34.196 41.6264 34.6847C41.6264 35.0114 41.5639 35.3324 41.4389 35.6477C41.3139 35.9631 41.0938 36.3125 40.7784 36.696C40.4659 37.0795 40.027 37.544 39.4616 38.0895L37.9574 39.6193V39.679H41.7585V41H35.7756Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 18.5,
    r: 7.5,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 54.5,
    r: 7.5,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegleta2);
export default __webpack_public_path__ + "static/media/regleta_2.c4ad76f62e1f674ccea1705aa189398e.svg";
export { ForwardRef as ReactComponent };